import { ChangeDetectorRef, Component, Input, forwardRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatChipsModule } from '@angular/material/chips';
import { TemplateNode } from 'src/app/components/product-certification/certifications/certifications/certification-template-editor/certification-template-editor.component';

@Component({
  selector: 'app-certification-template-tree-viewer',
  templateUrl: './certification-template-tree-viewer.component.html',
  styleUrls: ['./certification-template-tree-viewer.component.css'],
  standalone: true,
  imports: [
    CommonModule, 
    MatIconModule, 
    MatButtonModule, 
    MatChipsModule,
    forwardRef(() => CertificationTemplateTreeViewerComponent)
  ]
})
export class CertificationTemplateTreeViewerComponent {
  constructor(private cd: ChangeDetectorRef) { }
  @Input() nodes: TemplateNode[] = [];

  getTypeLabel(type: string): string {
    switch (type) {
      case 'number': return 'Zahl';
      case 'boolean': return 'Bool';
      case 'array': return 'Liste';
      case 'object': return 'Objekt';
      default: return 'Text';
    }
  }
  toggleExpand(node: TemplateNode) {
    node.expanded = !node.expanded;
    this.cd.detectChanges();
  }
}
